import { ITableColumn } from '@components/common/UTable/UTable';

export const columns = (dictionaries: any) =>
  [
    { title: '№ п/п', dataIndex: 'index', width: 50 },
    {
      title: 'Показания к применению',
      dataIndex: 'researchTypeId',
      type: 'select',
      width: 250,
      payload: {
        options: dictionaries?.RESEARCH_TYPE,
        fieldNames: {
          label: 'name',
          value: 'id',
        },
      },
    },
    {
      title: 'Дозировка',
      children: [
        {
          title: 'мл',
          children: [
            {
              title: 'от',
              dataIndex: 'dosageFrom',
            },
            {
              title: 'до',
              dataIndex: 'dosageTo',
            },
          ],
        },
        {
          title: 'кг',
          dataIndex: 'dosageWeight',
        },
      ],
    },
    {
      title: 'Тип применения',
      dataIndex: 'applicationTypeId',
      type: 'select',
      payload: {
        options: dictionaries?.APPLICATION_TYPE,
        fieldNames: {
          label: 'name',
          value: 'id',
        },
      },
    },
    {
      title: 'Вид животного',
      dataIndex: 'animalSpeciesId',
      type: 'select',
      payload: {
        options: dictionaries?.ANIMAL_SPECIES,
        fieldNames: {
          label: 'name',
          value: 'id',
        },
      },
    },
    {
      title: 'Возраст (дней)',
      children: [
        {
          title: 'от',
          dataIndex: 'ageFrom',
        },
        {
          title: 'до',
          dataIndex: 'ageTo',
        },
      ],
    },
    {
      title: 'Способ введения',
      dataIndex: 'administrationRouteIds',
      type: 'select',
      onCell: () => ({
        style: {
          maxWidth: 230,
          whiteSpace: 'normal',
          wordBreak: 'break-word',
        },
      }),
      payload: {
        mode: 'multiple',
        options: dictionaries?.ADMINISTRATION_ROUTE,
        fieldNames: {
          label: 'name',
          value: 'id',
        },
      },
    },
    {
      title: 'Примечание',
      dataIndex: 'note',
    },
  ] as ITableColumn[];
